<template>
  <div class="dropdown" :class="{ 'show': isOpen, 'dropup': dropup }">
    <button
      class="btn"
      :class="[buttonClass, 'dropdown-toggle']"
      type="button"
      @click.stop="toggle"
      :aria-expanded="isOpen"
    >
      <slot name="button-content">{{ text }}</slot>
    </button>
    <ul
      ref="menu"
      class="dropdown-menu"
      :class="{ 'show': isOpen, 'dropdown-menu-end': right }"
      @click.stop
    >
      <slot></slot>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue'

// Define props
const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'secondary'
  },
  right: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: false
  }
})

// Reactive data
const isOpen = ref(false)
const dropup = ref(false)

// Computed properties
const buttonClass = computed(() => {
  const classes = [`btn-${props.variant}`]
  if (props.block) {
    classes.push('w-100')
  }
  return classes.join(' ')
})

// Refs for DOM elements
const menuRef = ref(null)

// Lifecycle hooks
let clickHandler = null

onMounted(() => {
  // Create a closure to access the component's DOM element in the event handler
  clickHandler = (event) => {
    // Check if the click is outside the dropdown
    const dropdownElement = document.querySelector('.dropdown')
    if (dropdownElement && !dropdownElement.contains(event.target)) {
      close()
    }
  }
  
  document.addEventListener('click', clickHandler)
})

onUnmounted(() => {
  if (clickHandler) {
    document.removeEventListener('click', clickHandler)
  }
})

// Methods
const toggle = () => {
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    nextTick(() => {
      const menu = menuRef.value
      if (menu) {
        const rect = menu.getBoundingClientRect()
        dropup.value = rect.bottom > window.innerHeight
      }
    })
  } else {
    dropup.value = false
  }
}

const close = () => {
  isOpen.value = false
}

</script>

<style scoped>
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 5rem;
  width: auto;
  white-space: nowrap;
  border-radius: 0;
  display: none;
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.dropdown-menu.show {
  display: block;
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
}

.dropdown-menu.dropdown-menu-end {
  right: 0;
  left: auto;
}
</style>
